import { render } from "./P_Gunlance.vue?vue&type=template&id=1c46753e&scoped=true"
import script from "./P_Gunlance.vue?vue&type=script&lang=js"
export * from "./P_Gunlance.vue?vue&type=script&lang=js"

import "./P_Gunlance.vue?vue&type=style&index=0&id=1c46753e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c46753e"]])

export default __exports__